import Error404 from "../components/Errors/404"

export default [
    {
        path: '*',
        name: '404',
        component: Error404,
        meta: {
            fullscreen: true,
            requiresAuth: false
        }
    }
]